export default Object.freeze({
  LOCATION: 1,
  PRODUCT: 2,
  SLOT: 3,
  CUSTOMERS: 4,
});
